import React from "react";
import { Button, Input } from "../../components";
import { axios, Globals, Constants } from "../../utils";

class CreateEditModel extends React.Component {
  state = {
    form: {
      admin_id: this.props.user.level_id === Constants.ROLE_ADMIN ? this.props.user.id : this.props.user.admin_id,
    },
    textButton: "Crear"
  };
  componentDidMount() {
    if (this.props.edit) this.edit();
  }

  submit = async () => {
    let param = { ...this.state.form };
    Globals.setLoading();
    axios
      .upload(
        this.props.edit ? "web/admin/models/edit" : "web/admin/models/create",
        param
      )
      .then(res => {
        this.setState({
          form: {}
        });
        let msg = ''
        this.props.edit ? msg = "Modelo editado exitosamente" : msg = "Modelo creado exitosamente"
        Globals.showSuccess(msg);
        this.props.onClose();
      })
      .catch(err => {
        if (err.response.status === 422) {
          Globals.showError(err.response.data.msg);
          return;
        }
        Globals.showError();
      })
      .then(() => {
        Globals.quitLoading();
      });
  };

  edit = async () => {
    await this.setState({
      form: {
        name: this.props.edit.element.name,
        brand_id: this.props.edit.element.brand_id,
        id: this.props.edit.element.id
      },
      textButton: "Editar"
    });
  };

  change = e => {
    if (e.target.name === "code") {
      e.target.value = e.target.value.toUpperCase();
    }
    this.setState({
      form: {
        creator_id: this.props.user.id,
        brand_id: this.props.brand_id,
        ...this.state.form,
        [e.target.name]: e.target.value
      }
    });
  };

  render() {
    return (
      <div className="container-create-edit-user">
        <div className="row">
          <div className="col-md-12">
            <Input
              color=" "
              value={this.state.form.name}
              name="name"
              label="Nombre del modelo"
              labelClass="material"
              className="material"
              onChange={this.change}
            />
          </div>
          {/* <div className="col-md-12">
            <Input
              color=" "
              value={this.state.form.code}
              name="code"
              label="Código del modelo"
              labelClass="material"
              className="material"
              onChange={this.change}
            />
          </div> */}
        </div>
        <div id="button" className="d-flex justify-content-center">
          <Button
            color=" "
            type="button"
            className="primary"
            onClick={() => this.submit()}
          >
            {this.state.textButton}
          </Button>
        </div>
      </div>
    );
  }
}

export default CreateEditModel;
